<template>
  <b-card
    class="blog-edit-wrapper"
  >

    <!-- form -->
     <!-- <validation-observer ref="ariclesValidation"> -->
      <b-form class="mt-2">
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Nom complet"
              label-for="blog-edit-title"
              class="mb-2"
            >
              <b-form-input
                id="blog-edit-title"
                v-model="pharmacienEdit.nom"
                readonly
              />
            </b-form-group>
          </b-col>
          
          <b-col cols="12">
            <b-form-group
              label="Motif de bloquage"
              label-for="blog-content"
              class="mb-2"
            >
              
              <editor
                v-model="pharmacienEdit.body"
                api-key="iw2d576uwxj9tjfd66mq9bpa2frzhy7e6oks8nhpkiyt58v3"
                :init="{
                  height: 250,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                  ],
                  table_toolbar: 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
                  toolbar:
                    'undo redo | formatselect | bold italic backcolor | \
                    alignleft aligncenter alignright alignjustify | \
                    bullist numlist outdent indent | removeformat | table | help'
                }"
              />
            </b-form-group>
          </b-col>
          
          <b-col
            cols="12"
            class="mt-50"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="mr-1"
              @click="validationForm"
            >
              Bloquer
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
            >
              Annuler
            </b-button>
          </b-col>
        </b-row>
      </b-form>
     <!-- </validation-observer> -->
    <!--/ form -->
  </b-card>
</template>

<script>

import Editor from '@tinymce/tinymce-vue'

import {
  BCard, BMedia, BAvatar, BCardText, BMediaAside, BMediaBody, BForm, BRow, BCol, BFormGroup, BFormInput, BImg, BFormFile, BLink, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// import { quillEditor } from 'vue-quill-editor'
import Ripple from 'vue-ripple-directive'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import router from '@/router'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  
   props: {
    pharmacien: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      pharmacienEdit: {
        id: this.pharmacien?.id,
        nom: this.pharmacien?.fullName, 
        motif:  ''
        // featuredImage: '',
      },
      blogFile: null,
      snowOption: null,
      tableModule: null
    }
  },
  computed: {
      // editor() {
      //   return this.$refs.myQuillEditor.quill
      // }
  },
  mounted() {
    // this.tableModule = Quill.getModule('better-table')

    // this.snowOption = {
    //     theme: 'snow',
    //     modules: {
    //       table: false,  // disable table module
    //       'better-table': {
    //         operationMenu: {
    //           items: {
    //             unmergeCells: {
    //               text: 'Another unmerge cells name'
    //             }
    //           }
    //         }
    //       },
    //       keyboard: {
    //         bindings: QuillBetterTable.keyboardBindings
    //       }
    //     }
    // }
  },
  components: {
    'editor': Editor,
    BCard,
    BMedia,
    BAvatar,
    BCardText,
    BMediaAside,
    BMediaBody,
    BForm,
    BLink,
    BImg,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormFile,
    vSelect,
    // quillEditor,
  },
  directives: {
    Ripple,
  },
  created() {
  },
  setup(props) {
    console.log(props.pharmacien)
    if (props.pharmacien == null) {
    router.go(-1);
    } 

    const refInputEl = ref(null)
    const refPreviewEl = ref(null)
    const quillPreviewEl = ref(null)
    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => { refPreviewEl.value.src = base64 })



    return {
      refInputEl,
      refPreviewEl,
      quillPreviewEl,
      inputImageRenderer,
    }
  },
  methods: {
    validationForm() {

     
      try {

        this.$http.put('https://admin.ordredespharmaciens.sn/api/v1/dashboard/block-pharmacien-account/' + this.pharmacienEdit.id, {
          motif: this.pharmacienEdit.body 
        })
      .then(res => { 
        this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `Articles`,
              icon: 'CoffeeIcon',
              variant: 'success',
              text: `Le statut a été mis à jour avec succès !`,
            },
          })
          this.$router.replace("/pharmaciens");
       })

        //  console.log('testtest')
        // axios.put('https://admin.ordredespharmaciens.sn/api/v1/dashboard/block-pharmacien-account', this.pharmacienEdit.id, {
        //   motif: this.pharmacienEdit.motif 
        // }).then(res => { 
        //   // console.log(res);
        //   // this.$toast({
        //   //   component: ToastificationContent,
        //   //   position: 'top-right',
        //   //   props: {
        //   //     title: `Articles`,
        //   //     icon: 'CoffeeIcon',
        //   //     variant: 'success',
        //   //     text: `Le statut a été mis à jour avec succès !`,
        //   //   },
        //   // })
        //   // this.$router.replace("/pharmaciens");

        // })
      } catch (error) {
        console.log("error", error);
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/pages/page-blog.scss';
</style>
